<form id="form" autocomplete="chrome-off" autoFocusForm 
    (keyup.enter)="emit_onEnter()"
    [autofocusForm]="autofocus"
    [formGroup]="form" 
>
    <ng-container *ngTemplateOutlet="template$$()"></ng-container>
    
</form>
